import { Box } from "@mui/material";
import { formatNumber } from "src/utils/format-number";
import useLocales from "src/locales/use-locales";
import { SplitBarCellData } from "../split-bar-cell";
import BreakdownTooltip from "./breakdown-tooltip";

/** Per-column tooltip options of the split cells. */
export interface SplitTooltipOptions {
    /** Draw the split bar under the title (default true). */
    showBar?: boolean;
    /** 'share': each part's share, with its count when known (default); 'count': the count only. */
    values?: 'share' | 'count';
}

interface SplitBreakdownTooltipProps extends SplitTooltipOptions {
    data: SplitBarCellData[];
    total: number;
    format: (value: number) => string;
    onMouseLeave?: () => void;
    title: string;
}

/**
 * Search terms grid tooltip of the split cells (share of voice, traffic, conversions, revenue), Figma look:
 * one row per part, zero included, a dash for a part without data. The Competitors grid keeps GridDataTooltip.
 */
export default function SplitBreakdownTooltip({
    data,
    format,
    onMouseLeave = () => { },
    title,
    showBar = true,
    values = 'share',
}: SplitBreakdownTooltipProps) {
    const { t } = useLocales();
    const share = (item: SplitBarCellData) =>
        item.value === null || item.value === undefined ? '–' : item.format?.(item.value) || format(item.value);

    return (
        <Box onMouseLeave={onMouseLeave}>
            <BreakdownTooltip
                title={t(title)}
                segments={showBar ? data.map((item) => ({ value: item.value, color: item.color })) : undefined}
                rows={data.map((item) => ({
                    label: t(item.name),
                    color: item.color,
                    value:
                        values === 'count' ? (
                            formatNumber(item.help ?? 0)
                        ) : (
                            <>
                                {item.help ? <Box component="span" sx={{ color: '#333C47', mr: 1 }}>{formatNumber(item.help)}</Box> : null}
                                {share(item)}
                            </>
                        ),
                }))}
            />
        </Box>
    );
}
